import { render, staticRenderFns } from "./UsuariosCadastroFuncionario.vue?vue&type=template&id=49f2ca5c&"
import script from "./UsuariosCadastroFuncionario.vue?vue&type=script&lang=ts&"
export * from "./UsuariosCadastroFuncionario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports